PJQ.views.primeContracts.ChangeOrderDataTable = PJQ.views.dataTables.DataTable.extend({
    defaults: {
        language: {
            emptyTable: 'No Change Orders have been created yet',
            zeroRecords: "No Change Orders matched the search criteria"
        },
        subTemplates: {
            header: new PJQ.templating.Template(PJQ.constants.modules.PRIMECONTRACTS, 'data-table-header-change-orders')
        },
        toggleRowClass: '.change-order-toggle-row'
    },
    events: {
        'click .view-contract': 'viewPrimeContractClicked'
    },
    beforeDataTableRender: function () {
        this.options.pageLength = this.options.settings ? this.options.settings.rowsPerPage : 10;
    },
    getDefaultFilter: function () {
        return _.size(this.options.statusIds) > 0 ? this.options.statusIds : this.options.userSettings.get('defaultStatusFilter');
    },
    afterHeaderRender: function () {
        new PJQ.inputs.Selectpicker({
            el: this.$('.change-orders-status-filter'),
            defaultValue: this.getDefaultFilter(),
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.setFilter(PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER, value);
            }, this)
        });
        this.setFilter(PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER, this.getDefaultFilter());
    },
    getFilterData: function () {
        let statusFilter = this.getFilter(PJQ.constants.primeContracts.changeOrderFilterType.STATUS_FILTER);
        if (_.size(statusFilter) === 0) {
            return this.options.data;
        }

        return _.filter(this.options.data, function (row) {
            return (_.size(statusFilter) === 0 || _.contains(statusFilter, row.get('statusId')));
        });
    },
    getColumns: function (includeAllColumns = false) {
        this.options.canViewPrimeContracts = PJQ.app.session.project.hasPermission('primeContracts.canView');

        let columns = [],
            includeColumns = ['status', 'contract', 'number', 'changeReason', 'description', 'invoicedDate', 'dueDate', 'createdOn', 'amount', 'taxAmount', 'grandTotal'];

        if (this.options.customFields) {
            _.each(this.options.customFields.models, _.bind(function (customField) {
                includeColumns.push('fieldValue' + customField.get('fieldNumber'));
            }, this));
        }

        if (!includeAllColumns) {
            if (this.options.settings && _.size(this.options.settings.columns) > 0)
                includeColumns = this.options.settings.columns;
            else
                includeColumns = this.options.settings && this.options.settings.columnsDefault ? this.options.settings.columnsDefault : includeColumns;

            columns.push({
                "columnData": "childData",
                "data": null,
                "title": "",
                "width": "20px",
                "orderable": false,
                "searchable": false,
                "defaultContent": '',
                "render": (data, type, row) => {
                    if (!this.options.isAdmin) {
                        return "";
                    }

                    return PJQ.helpers.erp.getERPIcon(row.erpSyncStatus());
                }
            });
        }

        _.each(includeColumns, _.bind(function (columnName) {
            switch (columnName) {
                case 'status':
                    columns.push({
                        "columnData": "status",
                        "data": "attributes.statusId",
                        "title": "Status",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.constants.primeContracts.changeOrderStatusNames[row.get('statusId')]
                        }, this)
                    });
                    break;
                case 'contract':
                    columns.push({
                        "columnData": "contract",
                        "title": "Contract",
                        "data": "attributes.primeContractNumber",
                        "orderable": true,
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('primeContractNumber');
                            }

                            if (this.options.canViewPrimeContracts) {
                                return '<a class="view-contract" href="javascript:void(0)" data-id="' + row.get('primeContractId') + '">' + row.get('primeContractNumber') + '</a>';
                            }
                            return data;
                        }, this)
                    },);
                    break;
                case 'number':
                    columns.push({
                        "columnData": "number",
                        "data": "attributes.number",
                        "title": "Number",
                        "render": _.bind(function (data, type, row) {
                            if (type === 'sort' || type === 'type') {
                                return row.get('number');
                            }
                            return '<a href="javascript:void(0)" class="btn-view-change-order">' + data + '</a>'
                        }, this)
                    });
                    break;
                case 'changeReason':
                    columns.push({
                        "columnData": "changeReason",
                        "data": "attributes.changeReason",
                        "title": "Change Reason"
                    });
                    break;
                case 'description':
                    columns.push({
                        "columnData": "description",
                        "data": "attributes.description",
                        "title": "Description"
                    });
                    break;
                case 'invoicedDate':
                    columns.push({
                        "columnData": "invoicedDate",
                        "data": "attributes.invoicedDate",
                        "title": 'Invoiced Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'dueDate':
                    columns.push({
                        "columnData": "dueDate",
                        "data": "attributes.dueDate",
                        "title": 'Due Date',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                        }, this)
                    });
                    break;
                case 'createdOn':
                    columns.push({
                        "columnData": "createdOn",
                        "data": "attributes.createdOn",
                        "title": 'Created',
                        "width": '90px',
                        "render": _.bind(function (data, type, row) {
                            if (_.size(data) === 0) {
                                return '';
                            } else if (type === 'sort' || type === 'type') {
                                return data ? new Date(data) : null;
                            }
                            return PJQ.helpers.dateHelpers.getDateString(new Date(data), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                        }, this)
                    });
                    break;
                case 'client.companyName':
                    columns.push({
                        "columnData": "client.companyName",
                        "title": "Client",
                        "titleSettings": "Client",
                        "render": _.bind(function (data, type, row) {
                            return row.get('client') ? row.get('client').companyName : 'N/A';
                        }, this)
                    });
                    break;
                case 'amount':
                    columns.push({
                        "columnData": "amount",
                        "data": "attributes.amount",
                        "title": "Amount",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'taxAmount':
                    columns.push({
                        "columnData": "taxAmount",
                        "data": "attributes.taxAmount",
                        "title": "Tax",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(data);
                        }, this)
                    });
                    break;
                case 'grandTotal':
                    columns.push({
                        "columnData": "grandTotal",
                        "data": "attributes.amount",
                        "title": "Grand Total",
                        "width": "100px",
                        "render": _.bind(function (data, type, row) {
                            return PJQ.helpers.formatHelpers.formatCurrency(row.getGrandTotal());
                        }, this)
                    });
                    break;
                default:
                    if (columnName.startsWith('fieldValue')) {
                        _.each(this.options.customFields.models, function (customField) {
                            if (columnName === 'fieldValue' + customField.get('fieldNumber')) {
                                columns.push({
                                    "columnData": 'fieldValue' + customField.get('fieldNumber'),
                                    "title": customField.get('name'),
                                    "render": function (data, type, row) {
                                        let fieldValue = row.getCustomFieldValue(customField.get('id'));
                                        fieldValue = (fieldValue !== null) ? fieldValue : '';
                                        switch (customField.get('fieldTypeId')) {
                                            case PJQ.constants.commitments.customFieldType.BOOLEAN:
                                                if (fieldValue != null)
                                                    fieldValue = fieldValue ? 'Yes' : 'No';
                                                break;
                                            case PJQ.constants.commitments.customFieldType.CHOICE:
                                                let choices = [];
                                                // convert single choice value into array so that the logic below can work for both types.
                                                if (typeof fieldValue === 'number')
                                                    fieldValue = [fieldValue];

                                                _.each(customField.choices.models, _.bind(function (choice) {
                                                    if (_.find(fieldValue, function (value) {
                                                        return value === choice.get('id');
                                                    }))
                                                        choices.push(choice.get('name'));
                                                }, this));

                                                fieldValue = choices.join((', '));
                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATE:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE, true);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.DATETIME:
                                                if (fieldValue) {
                                                    if (type !== 'sort' && type !== 'type')
                                                        fieldValue = PJQ.helpers.dateHelpers.getDateString(new Date(fieldValue), PJQ.helpers.dateHelpers.dateFormats.DATE_TIME);
                                                }
                                                if (fieldValue === undefined)
                                                    fieldValue = '';

                                                break;
                                            case PJQ.constants.commitments.customFieldType.INTEGER:
                                                if (type !== 'sort' && type !== 'type' && fieldValue) {
                                                    fieldValue = parseInt(fieldValue).toLocaleString();
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.MONEY:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true));
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = PJQ.helpers.formatHelpers.formatCurrency(parseInt(PJQ.helpers.formatHelpers.numbersOnly(fieldValue)));
                                                }
                                                break;
                                            case PJQ.constants.commitments.customFieldType.PERCENT:
                                                if (type === 'sort' || type === 'type') {
                                                    if (fieldValue && fieldValue !== '$')
                                                        fieldValue = parseFloat(PJQ.helpers.formatHelpers.numbersOnly(fieldValue, true)).toFixed(2);
                                                    else
                                                        fieldValue = 0;
                                                } else {
                                                    fieldValue = fieldValue ? fieldValue.toString() + '%' : '';
                                                }

                                                break;
                                        }

                                        return fieldValue;
                                    }
                                });
                            }
                        });
                    }
                    break;
            }
        }, this));

        if (!includeAllColumns) {
            columns.push({
                "title": '',
                "render": _.bind(function (data, type, row) {
                    return '<div class="show-on-row-hover"><button type="button" class="btn btn-info btn-view-change-order ml-1" title="View change orrder"><i class="fal fa-arrow-alt-from-left"></i></button></div>';
                }, this),
                "orderable": false,
                "searchable": false,
                "width": "90px",
                "className": "text-center",
                "visible": true
            });
        }

        return columns;
    },
    viewPrimeContractClicked: function (e) {
        let row = this.getRow((e.currentTarget).closest('tr'));
        this.viewPrimeContract(row.data().get('primeContractId'));
    },
    viewPrimeContract: function (primeContractId) {
        new PJQ.views.primeContracts.PrimeContractEditModal({
            model: new PJQ.models.primeContracts.PrimeContract({
                id: primeContractId
            })
        });
    }
});